module.exports = __webpack_public_path__ + "img/quote-close.38bc2a1b.svg";